import { render, staticRenderFns } from "./add-delivery-rate-popup.vue?vue&type=template&id=18903c91"
import script from "./add-delivery-rate-popup.vue?vue&type=script&lang=js"
export * from "./add-delivery-rate-popup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports